<template>
  <a-button
    type="text"
    @click="
      showModal();
      $emit('click');
    "
    :disabled="item.status === 2"
    :class="item.status === 2 ? 'button-disabled' : ''"
  >
    <template #icon>
      <EditOutlined />
    </template>

    Editar submotivo
  </a-button>

  <a-drawer
    :visible="visible"
    :title="`Editar submotivo - ${item.name}`"
    width="400px"
    centered
    :mask-closable="false"
    :keyboard="false"
    @close="handleConfirmationClose"
  >
    <typification-edit-warning />

    <div class="title">
      <div class="group">
        <h4>Grupo:</h4>
        <h5>{{ itemgroup.name }}</h5>
      </div>
      <div class="result group">
        <h4>Resultado:</h4>
        <h5>{{ itemresult.name }}</h5>
        <div class="result">
          <h4>Motivo:</h4>
          <h5>{{ itemmotive.name }}</h5>
        </div>
      </div>
    </div>
    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-item label="Nombre del submotivo" name="name">
        <a-input v-model:value="formState.name" placeholder="Escribir nombre del submotivo" />
      </a-form-item>

      <a-form-item name="code">
        <template #label>
          <span class="label">
            Código de integración
            <a-tooltip>
              <template v-slot:title>
                Código de identificación para exportaciones o integraciones
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <a-input v-model:value="formState.code" placeholder="Escribir código aquí..." />
      </a-form-item>
    </a-form>

    <fixed-footer
      confirmText="Editar submotivo"
      @onCancel="cancelModal"
      @onConfirm="handleSubmit"
      cancelText="Cancelar"
    />
  </a-drawer>
</template>

<script>
import { defineComponent, reactive, ref, toRaw, createVNode } from "vue";
import { EditOutlined, InfoCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import FixedFooter from "@/app/shared/components/sections/FixedFooter.vue";
import TypificationEditWarning from "@/app/entities/components/sections/TypificationEditWarning.vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    EditOutlined,
    InfoCircleOutlined,
    FixedFooter,
    TypificationEditWarning,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
    itemgroup: {
      required: true,
      type: Object,
    },
    itemresult: {
      required: true,
      type: Object,
    },
    itemmotive: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    const formRef = ref();
    const formState = reactive({
      name: props.item.name,
      code: props.item.code,
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      code: [],
    };

    return {
      formRef,
      formState,
      rules,
    };
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleSubmit() {
      this.formRef.validateFields().then(() => {
        let values = toRaw(this.formState);
        delete this.item.form_id;
        if (this.item.name == values.name) {
          delete values.name;
        }
        this.$emit("change", {
          ...this.item,
          ...values,
          group: this.itemgroup.id,
          result: this.itemresult.id,
          motive: this.itemmotive.id,
        });
        this.visible = false;
        this.formRef.resetFields();
      });
    },
    showModal() {
      this.visible = true;
      this.formState.name = this.item.name;
      this.formState.code = this.item.code;
    },
    cancelModal() {
      this.visible = false;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de descartar cambios?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.cancelModal(),
        centered: true,
        okText: "Descartar",
        cancelText: "Cancelar",
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.result
  margin-left: 28px
  margin-top: 18px

.title
  margin-bottom: 24px
.button-disabled
  opacity: 0.4
</style>
